import { render, staticRenderFns } from "./IntegralRecord.vue?vue&type=template&id=4dba6e30&scoped=true&"
import script from "./IntegralRecord.vue?vue&type=script&lang=js&"
export * from "./IntegralRecord.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRecord.vue?vue&type=style&index=0&id=4dba6e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba6e30",
  null
  
)

export default component.exports